import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

//interfaces
import { ArticleInterface } from '../shared/interfaces';

//services
import { OrderService } from '../shared/services';

//helpers
import { OrderHelper } from '../shared/helpers';
import { ProductIdentifierEnum, ProductTypeEnum } from '../shared/enums';
import { SetImagePipe } from '../shared/pipes/image.pipe';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrl: './category.component.scss'
})
export class CategoryComponent implements OnInit {
  @ViewChild('modal', { static: false }) modal: ElementRef;

  public products: ArticleInterface[] = [];
  public selectedProduct: ArticleInterface | null = null;
  public quantity: number = 1;
  public categoryTitle: string;

  public categoryId: string;

  constructor(
    private orderHelper: OrderHelper,
    private orderService: OrderService,
    private route: ActivatedRoute,
    private setImages: SetImagePipe
  ) {
    this.categoryId = this.route.snapshot.paramMap.get('categoryId')!;
  }

  ngOnInit(): void {
    this.orderService.getArticlesByCategory(this.categoryId).subscribe({
      next: data => {
        this.categoryTitle = data.category;
        this.setImages.transform(data.articleList).then((articles) => {
          this.products = articles;
        })
      },
      error: err => {
        console.log(err);
      }
    })
  }

  public submit() {
    this.orderHelper.addToBasket(this.selectedProduct!.id, ProductIdentifierEnum.id, ProductTypeEnum.regularProduct, this.quantity);
    this.orderHelper.recalculateOrder();
    this.close()
  }

  public fallback() {
    OrderService.fallback.next(true);
  }
  errorHandler(event: any) {
    console.log(event)
    event.target.src = '/assets/images/' + this.categoryId + '.svg'
  }

  public close() {
    this.modal.nativeElement.classList.add('close')
    setTimeout(() => {
      this.selectedProduct = null;
      this.quantity = 1;
      this.modal.nativeElement.classList.remove('close')
    }, 300);
  }
}
